import React from 'react';
import Button, { btnThemes } from 'components/button';
import { ModalButton, Header, Content } from 'components/modal';
import { iconTypes } from 'components/icon';

import ChangeUserPostContent from './change-user-post-content';
import MovePostContent from './move-post-content';
import MergePostsContent from './merge-posts-content';

export default function (bemClasses) {
  const { onHandleDelete, onResetSelection, selectedItems } = this.props;

  return (
    <>
      <ModalButton
        {...bemClasses('item')}
        buttonProps={{
          iconType: iconTypes.newTab,
          title: 'Переместить',
          iconOnly: true,
          theme: btnThemes.white
        }}
        classNameModal={bemClasses('modal').className}
        size="big"
      >
        <Header closeButton children="Переместить сообщение" />
        <Content adaptiveHeight>
          <div>
            <MovePostContent
              onResetSelection={onResetSelection}
              selectedItems={selectedItems}
            />
          </div>
        </Content>
      </ModalButton>
      {selectedItems && selectedItems.length > 1 &&
        <ModalButton
          {...bemClasses('item')}
          buttonProps={{
            iconType: iconTypes.pages,
            title: 'Объединить сообщения',
            iconOnly: true,
            theme: btnThemes.white
          }}
          classNameModal={bemClasses('modal').className}
          size="big"
        >
          <Header closeButton children="Объединить сообщения" />
          <Content adaptiveHeight>
            <div>
              <MergePostsContent
                selectedItems={selectedItems}
                onResetSelection={onResetSelection}
              />
            </div>
          </Content>
        </ModalButton>
      }
      <ModalButton
        {...bemClasses('item')}
        buttonProps={{
          iconType: iconTypes.person,
          title: 'Заменить автора сообщения',
          iconOnly: true,
          theme: btnThemes.white
        }}
        classNameModal={bemClasses('modal').className}
        size="big"
      >
        <Header closeButton children="Заменить автора сообщения" />
        <Content adaptiveHeight>
          <div>
            <ChangeUserPostContent
              onResetSelection={onResetSelection}
              selectedItems={selectedItems}
            />
          </div>
        </Content>
      </ModalButton>
      <Button
        {...bemClasses('item')}
        iconType={iconTypes.delete}
        title="Удалить"
        onClick={() => onHandleDelete(selectedItems, true)}
        iconOnly
        theme={btnThemes.white}
      />
    </>
  );
}
